import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useNavigation } from '../hooks/useNavigation';

/**
 * Componente que maneja redirecciones automáticas basadas en roles
 * @param {Object} props - Las props del componente
 * @param {React.ReactNode} props.children - Componente hijo a renderizar
 */
const RoleBasedRedirect = ({ children }) => {
  const { isSupervisor, getDefaultRoute } = useNavigation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Si es Supervisor y está en el dashboard (raíz), redirigir a Tareos
    if (isSupervisor && location.pathname === '/') {
      navigate('/tareos', { replace: true });
    }
  }, [isSupervisor, location.pathname, navigate]);

  return children;
};

export default RoleBasedRedirect;